var map = {
	"./en/coverStrip.json": "x0QU",
	"./en/findUsStrip.json": "huUM",
	"./en/footer.json": "Ex8V",
	"./en/form.json": "B82N",
	"./en/formStrip.json": "XrKH",
	"./en/general.json": "LmU7",
	"./en/header.json": "6sEY",
	"./en/helmet.json": "rZoq",
	"./en/languageSwitcher.json": "LFzI",
	"./en/methodStrip.json": "UXas",
	"./en/newsStrip.json": "WiJX",
	"./en/notFoundPage.json": "1bz8",
	"./en/openWorksHomePageStrip.json": "qSop",
	"./en/servicesStrip.json": "BZNO",
	"./it/coverStrip.json": "Oyvn",
	"./it/findUsStrip.json": "/1sc",
	"./it/footer.json": "rHJq",
	"./it/form.json": "f0gh",
	"./it/formStrip.json": "ULiV",
	"./it/general.json": "ENQw",
	"./it/header.json": "HZh6",
	"./it/helmet.json": "DuPr",
	"./it/languageSwitcher.json": "OOhg",
	"./it/methodStrip.json": "djjg",
	"./it/newsStrip.json": "MuOs",
	"./it/notFoundPage.json": "9RJk",
	"./it/openWorksHomePageStrip.json": "PtMI",
	"./it/servicesStrip.json": "wcm5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WoIT";